module.exports = __webpack_public_path__ + "img/1.be272103.png";